// /Users/pramod/Desktop/school-erp/frontend/src/Tenant-Admin/ManageStaff/StaffCard.js
import React from 'react';
import { Eye, Edit3, ShieldAlert, ShieldCheck, Trash2 } from 'lucide-react';

const StaffCard = ({
  member,
  selected,
  onSelect,
  onEdit,
  onStatusToggle,
  onDelete,
  onViewDetails
}) => {
  // Exclude tenant_admin users
  if (member.role && member.role.toLowerCase() === 'tenant_admin') return null;

  const fullName = `${member.firstName || ''} ${member.lastName || ''}`.trim() || 'Unknown';
  const initials = fullName
    .split(' ')
    .map(n => n[0])
    .join('')
    .toUpperCase()
    .slice(0, 2);

  return (
    <div className={`px-4 py-3.5 sm:px-6 sm:py-4 transition-colors border-b border-slate-100 last:border-b-0 ${
      selected ? 'bg-slate-50' : 'hover:bg-slate-50/60'
    }`}>
      <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-3.5">
        
        {/* Profile Details Cluster */}
        <div className="flex items-start gap-3 min-w-0 flex-1">
          {/* Checkbox Trigger Zone */}
          <div className="pt-1 flex shrink-0 items-center h-10">
            <input
              type="checkbox"
              checked={selected}
              onChange={onSelect}
              className="h-4 w-4 rounded-md border-slate-300 text-slate-900 focus:ring-slate-900 focus:ring-1"
            />
          </div>
          
          {/* Neutral Professional Avatar Initials */}
          <div className="h-10 w-10 shrink-0 bg-slate-100 border border-slate-200 rounded-xl flex items-center justify-center">
            <span className="text-slate-700 font-bold text-xs tracking-wide">{initials}</span>
          </div>

          {/* Typography Profile Matrix */}
          <div className="min-w-0 flex-1 leading-normal">
            <div className="flex items-center gap-2 flex-wrap sm:flex-nowrap">
              <h3 className="text-xs sm:text-sm font-bold text-slate-900 truncate">
                {fullName}
              </h3>
              <span className={`inline-flex items-center px-2 py-0.5 rounded-md text-[10px] font-bold uppercase tracking-wider ${
                member.status === 'active'
                  ? 'bg-emerald-50 text-emerald-700 border border-emerald-100'
                  : 'bg-slate-100 text-slate-500 border border-slate-200'
              }`}>
                {member.status === 'active' ? 'Active' : 'Disabled'}
              </span>
            </div>
            
            <p className="text-xs text-slate-400 font-medium truncate mt-0.5">{member.email}</p>
            
            <div className="flex items-center gap-2.5 mt-1 text-[11px] text-slate-500 font-medium">
              <span className="text-indigo-600 font-semibold bg-indigo-50/50 px-1.5 py-0.5 rounded-sm">
                {member.role ? member.role.charAt(0).toUpperCase() + member.role.slice(1).toLowerCase() : ''}
              </span>
              {member.phoneNumber && (
                <>
                  <span className="text-slate-200 select-none">•</span>
                  <span className="truncate">{member.phoneNumber}</span>
                </>
              )}
            </div>
          </div>
        </div>

        {/* Action Controls Tool Matrix (Full width responsive spacing on phones) */}
        <div className="flex items-center gap-1 sm:gap-0.5 justify-end border-t sm:border-t-0 border-slate-100 pt-2 sm:pt-0 shrink-0">
          <button
            onClick={onViewDetails}
            type="button"
            className="text-slate-500 hover:text-slate-900 hover:bg-slate-100 p-2 rounded-xl transition-colors flex-1 sm:flex-none justify-center flex"
            title="View Details"
          >
            <Eye size={15} />
          </button>
          
          <button
            onClick={onEdit}
            type="button"
            className="text-slate-500 hover:text-slate-900 hover:bg-slate-100 p-2 rounded-xl transition-colors flex-1 sm:flex-none justify-center flex"
            title="Edit"
          >
            <Edit3 size={15} />
          </button>

          <button
            onClick={onStatusToggle}
            type="button"
            className={`p-2 rounded-xl transition-colors flex-1 sm:flex-none justify-center flex ${
              member.status === 'active'
                ? 'text-amber-600 hover:text-amber-700 hover:bg-amber-50'
                : 'text-emerald-600 hover:text-emerald-700 hover:bg-emerald-50'
            }`}
            title={member.status === 'active' ? 'Disable Account' : 'Enable Account'}
          >
            {member.status === 'active' ? <ShieldAlert size={15} /> : <ShieldCheck size={15} />}
          </button>

          <button
            onClick={onDelete}
            type="button"
            className="text-rose-600 hover:text-rose-700 hover:bg-rose-50 p-2 rounded-xl transition-colors flex-1 sm:flex-none justify-center flex"
            title="Delete Record"
          >
            <Trash2 size={15} />
          </button>
        </div>

      </div>
    </div>
  );
};

export default StaffCard;